import React from "react";
import { cn, getInitials } from "../../lib/utils";

export function UserAvatar({ user, size = "md", className }) {
    const sizeClasses = {
        sm: "w-6 h-6 text-[10px]",
        md: "w-8 h-8 text-xs",
        lg: "w-10 h-10 text-sm",
        xl: "w-12 h-12 text-base",
    };

    if (!user) {
        return (
            <div
                className={cn(
                    "rounded-full bg-gray-200 flex items-center justify-center font-medium text-gray-500",
                    sizeClasses[size],
                    className
                )}
            >
                ?
            </div>
        );
    }

    return (
        <div
            className={cn(
                "rounded-full bg-gray-700 flex items-center justify-center font-medium text-white overflow-hidden",
                sizeClasses[size],
                className
            )}
            title={`${user.first_name} ${user.last_name}`}
        >
            {user.avatar_url ? (
                <img
                    src={user.avatar_url}
                    alt=""
                    className="w-full h-full object-cover"
                />
            ) : (
                getInitials(user.first_name, user.last_name)
            )}
        </div>
    );
}

export function UserDisplay({ user, showEmail = false, className }) {
    if (!user) {
        return <span className="text-gray-400">Non assigné</span>;
    }

    return (
        <div className={cn("flex items-center gap-2", className)}>
            <UserAvatar user={user} size="sm" />
            <div className="min-w-0">
                <div className="text-sm font-medium text-gray-900 truncate flex items-center gap-1.5">
                    <span className="truncate">{user.first_name} {user.last_name}</span>
                    {(user.entra_status === "deleted" || user.entra_status === "disabled" || user.left_company_at) && (
                        <span className="text-[9px] px-1.5 py-0.5 rounded-full font-semibold bg-rose-100 text-rose-700 whitespace-nowrap flex-shrink-0" title="A quitté l'entreprise" data-testid={`left-pill-${user.id}`}>Parti·e</span>
                    )}
                </div>
                {showEmail && (
                    <div className="text-xs text-gray-500 truncate">{user.email}</div>
                )}
            </div>
        </div>
    );
}
